var React = require('react');

function Up (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(1.041 1.081)"},React.createElement("path",{"d":"M1550.737,3757.844l5.951-6.184-22.657-23.5-22.656,23.5,5.951,6.184,16.706-17.362Z","transform":"translate(-1511.375 -3728.156)","fill":"none","stroke":"#000","strokeMiterlimit":"10","strokeWidth":"1.5"})));
}

Up.defaultProps = {"width":"47.396","height":"31.85","viewBox":"0 0 47.396 31.85"};

module.exports = Up;

Up.default = Up;
